module.exports = __webpack_public_path__ + "img/front_slit_length.a1ab107a.png";